import React, { useState, useMemo } from "react";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { CSVLink } from "react-csv";
import { FiUsers, FiCheckCircle, FiClock, FiBox } from "react-icons/fi";



function VendorReport() {
  // Sample vendor data
  const [vendors] = useState([
    {
      id: 1,
      name: "TechStore Pvt Ltd",
      email: "contact@techstore.com",
      phone: "+91 9876543210",
      category: "Electronics",
      totalProducts: 120,
      activeSKUs: 100,
      approvedOn: "2025-08-15",
      status: "Approved",
      createdAt: "2025-07-01",
      logo: "https://via.placeholder.com/60",
    },
    {
      id: 2,
      name: "FitGear",
      email: "support@fitgear.com",
      phone: "+91 9123456780",
      category: "Footwear",
      totalProducts: 80,
      activeSKUs: 75,
      approvedOn: "2025-08-20",
      status: "Approved",
      createdAt: "2025-06-25",
      logo: "https://via.placeholder.com/60",
    },
    {
      id: 3,
      name: "HomeEssentials",
      email: "hello@homeessentials.com",
      phone: "+91 9988776655",
      category: "Home & Kitchen",
      totalProducts: 60,
      activeSKUs: 40,
      approvedOn: "2025-08-22",
      status: "Pending",
      createdAt: "2025-07-05",
      logo: "https://via.placeholder.com/60",
    },
  ]);

  const [filters, setFilters] = useState({
    search: "",
    category: "All",
    status: "All",
    dateFrom: null,
    dateTo: null,
  });

  const [showFilter, setShowFilter] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleDateChange = (name, date) => {
    setFilters({ ...filters, [name]: date[0] });
  };

  // Filter vendors based on search, category, status, date
  const filteredVendors = useMemo(() => {
    return vendors.filter((v) => {
      const matchesSearch =
        v.name.toLowerCase().includes(filters.search.toLowerCase()) ||
        v.email.toLowerCase().includes(filters.search.toLowerCase()) ||
        v.phone.toLowerCase().includes(filters.search.toLowerCase());

      const matchesCategory =
        filters.category === "All" || v.category === filters.category;

      const matchesStatus =
        filters.status === "All" || v.status === filters.status;

      const matchesDate =
        (!filters.dateFrom || new Date(v.approvedOn) >= filters.dateFrom) &&
        (!filters.dateTo || new Date(v.approvedOn) <= filters.dateTo);

      return matchesSearch && matchesCategory && matchesStatus && matchesDate;
    });
  }, [vendors, filters]);

  const categories = ["All", ...new Set(vendors.map((v) => v.category))];

  // Pagination
  const indexOfLast = currentPage * rowsPerPage;
  const indexOfFirst = indexOfLast - rowsPerPage;
  const currentVendors = filteredVendors.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredVendors.length / rowsPerPage);

  // Report Summary
  const reportSummary = {
    totalVendors: filteredVendors.length,
    approved: filteredVendors.filter((v) => v.status === "Approved").length,
    pending: filteredVendors.filter((v) => v.status === "Pending").length,
    totalSKUs: filteredVendors.reduce((sum, v) => sum + v.activeSKUs, 0),
  };

  return (
    <>
      <Topbar />
      <Sidebar />
      <main className="main-wrapper">
        <div className="main-content">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="breadcrumb-title">Vendor Report</h4>
            <div>
              <button
                className="btn btn-primary me-2"
                onClick={() => setShowFilter(true)}
              >
                Filters
              </button>
              <CSVLink
                data={filteredVendors}
                filename={"vendor-report.csv"}
                className="btn btn-primary"
              >
                Export CSV
              </CSVLink>
            </div>
          </div>

          {/* Report Summary */}
          <div className="row mb-3">
  {/* Total Vendors */}
  <div className="col-md-3">
    <div className="kpi-card bg-soft-primary d-flex align-items-center p-3">
      <div className="kpi-icon">
        <FiUsers size={30} className="text-primary" />
      </div>
      <div className="kpi-content ms-3">
        <h6>Total Vendors</h6>
        <h2>{reportSummary.totalVendors}</h2>
        <p className="text-success">↑ 10% from last month</p>
      </div>
    </div>
  </div>

  {/* Approved Vendors */}
  <div className="col-md-3">
    <div className="kpi-card bg-soft-primary d-flex align-items-center p-3">
      <div className="kpi-icon">
        <FiCheckCircle size={30} className="text-success" />
      </div>
      <div className="kpi-content ms-3">
        <h6>Approved</h6>
        <h2>{reportSummary.approved}</h2>
        <p className="text-success">↑ 5% from last month</p>
      </div>
    </div>
  </div>

  {/* Pending Vendors */}
  <div className="col-md-3">
    <div className="kpi-card bg-soft-primary d-flex align-items-center p-3">
      <div className="kpi-icon">
        <FiClock size={30} className="text-warning" />
      </div>
      <div className="kpi-content ms-3">
        <h6>Pending</h6>
        <h2>{reportSummary.pending}</h2>
        <p className="text-danger">↓ 2% from last month</p>
      </div>
    </div>
  </div>

  {/* Total Active SKUs */}
  <div className="col-md-3">
    <div className="kpi-card bg-soft-primary d-flex align-items-center p-3">
      <div className="kpi-icon">
        <FiBox size={30} className="text-info" />
      </div>
      <div className="kpi-content ms-3">
        <h6>Total Active SKUs</h6>
        <h2>{reportSummary.totalSKUs}</h2>
        <p className="text-success">↑ 8% from last month</p>
      </div>
    </div>
  </div>
</div>


          {/* Vendor Table */}
          <div className="col-12">
            <div className="card shadow-sm border-0">
              <div className="card-body table-responsive">
                <table className="table table-hover table-striped align-middle">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Logo</th>
                      <th>Vendor Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Category</th>
                      <th>Total Products</th>
                      <th>Active SKUs</th>
                      <th>Status</th>
                      <th>Approved On</th>
                      <th>Created At</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentVendors.map((v) => (
                      <tr key={v.id}>
                        <td>{v.id}</td>
                        <td>
                          <img
                            src={v.logo}
                            alt={v.name}
                            className="rounded"
                            style={{
                              width: "60px",
                              height: "60px",
                              objectFit: "cover",
                            }}
                          />
                        </td>
                        <td>{v.name}</td>
                        <td>{v.email}</td>
                        <td>{v.phone}</td>
                        <td>{v.category}</td>
                        <td>{v.totalProducts}</td>
                        <td>{v.activeSKUs}</td>
                        <td>
                          <span
                            className={`badge ${
                              v.status === "Approved"
                                ? "bg-success"
                                : v.status === "Pending"
                                ? "bg-warning"
                                : "bg-secondary"
                            }`}
                          >
                            {v.status}
                          </span>
                        </td>
                        <td>{v.approvedOn}</td>
                        <td>{v.createdAt}</td>
                        <td>
                          <div className="d-flex gap-1 flex-wrap">
                            <button className="btn btn-sm btn-primary">
                              View
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* Pagination Controls */}
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div>
                    Rows per page:{" "}
                    <select
                      value={rowsPerPage}
                      onChange={(e) => {
                        setRowsPerPage(Number(e.target.value));
                        setCurrentPage(1);
                      }}
                    >
                      {[5, 10, 20, 50].map((n) => (
                        <option key={n} value={n}>
                          {n}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                      (page) => (
                        <button
                          key={page}
                          className={`btn btn-sm ${
                            currentPage === page
                              ? "btn-primary"
                              : "btn-outline-primary"
                          } mx-1`}
                          onClick={() => setCurrentPage(page)}
                        >
                          {page}
                        </button>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Filter Panel */}
          <div className={`filter-panel ${showFilter ? "open" : ""}`}>
            <div className="filter-header">
              <h5>Filters</h5>
              <button
                className="btn-close"
                onClick={() => setShowFilter(false)}
              ></button>
            </div>
            <div className="filter-body">
              <div className="mb-3">
                <label>Search</label>
                <input
                  type="text"
                  className="form-control"
                  name="search"
                  placeholder="Vendor name, email or phone"
                  value={filters.search}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="mb-3">
                <label>Category</label>
                <select
                  className="form-control"
                  name="category"
                  value={filters.category}
                  onChange={handleFilterChange}
                >
                  {categories.map((c) => (
                    <option key={c} value={c}>
                      {c}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label>Status</label>
                <select
                  className="form-control"
                  name="status"
                  value={filters.status}
                  onChange={handleFilterChange}
                >
                  <option value="All">All</option>
                  <option value="Approved">Approved</option>
                  <option value="Pending">Pending</option>
                </select>
              </div>
              <div className="mb-3">
                <label>Approved From</label>
                <Flatpickr
                  value={filters.dateFrom}
                  onChange={(date) => handleDateChange("dateFrom", date)}
                  options={{ dateFormat: "Y-m-d" }}
                  className="form-control"
                />
              </div>
              <div className="mb-3">
                <label>Approved To</label>
                <Flatpickr
                  value={filters.dateTo}
                  onChange={(date) => handleDateChange("dateTo", date)}
                  options={{ dateFormat: "Y-m-d" }}
                  className="form-control"
                />
              </div>
              <button
                className="btn btn-primary w-100"
                onClick={() => setShowFilter(false)}
              >
                Apply Filters
              </button>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default VendorReport;
